import { BASEURL } from "../../../constant";
import { loaded } from "../actions";

const fetchTodos = async (dispatch) => {
  const response = await fetch(BASEURL + "/todos");
  const todos = await response.json();

  dispatch(loaded(todos));
};

export default fetchTodos;
